// 货币时间价值（TVM）与IRR计算引擎（纯函数）

function round(x, digits = 2) {
  const k = Math.pow(10, digits)
  return Math.round((x + Number.EPSILON) * k) / k
}

// 普通年金现值/未来值
function pvAnnuity(pmt, r, n) {
  if (n <= 0) return 0
  if (r === 0) return pmt * n
  return pmt * (1 - Math.pow(1 + r, -n)) / r
}

function fvAnnuity(pmt, r, n) {
  if (n <= 0) return 0
  if (r === 0) return pmt * n
  return pmt * (Math.pow(1 + r, n) - 1) / r
}

// 由 PV 求 PMT（普通年金）
function pmtFromPV(PV, r, n) {
  if (n <= 0) return 0
  if (r === 0) return PV / n
  return PV * r / (1 - Math.pow(1 + r, -n))
}

// 由 FV 求 PMT（普通年金）
function pmtFromFV(FV, r, n) {
  if (n <= 0) return 0
  if (r === 0) return FV / n
  return FV * r / (Math.pow(1 + r, n) - 1)
}

// 由 PV,pmt 求 n
function nFromPV(PV, r, pmt) {
  if (r === 0) return PV / pmt
  const ratio = 1 - (PV * r) / pmt
  if (ratio <= 0) return Infinity
  return -Math.log(ratio) / Math.log(1 + r)
}

// 由 FV,pmt 求 n
function nFromFV(FV, r, pmt) {
  if (r === 0) return FV / pmt
  const ratio = 1 + (FV * r) / pmt
  if (ratio <= 0) return Infinity
  return Math.log(ratio) / Math.log(1 + r)
}

// 由 PV,pmt,n 反求 r （二分法）
function rateFromPV(PV, n, pmt, { tol = 1e-10, maxIter = 100, rLow = 0, rHigh = 1 } = {}) {
  const f = (r) => pvAnnuity(pmt, r, n) - PV
  let low = rLow, high = rHigh
  let fLow = f(low), fHigh = f(high)
  let expand = 0
  while (fLow * fHigh > 0 && expand < 8) {
    high *= 2
    fHigh = f(high)
    expand++
  }
  for (let i = 0; i < maxIter; i++) {
    const mid = (low + high) / 2
    const fMid = f(mid)
    if (Math.abs(fMid) < tol) return mid
    if (fLow * fMid <= 0) { high = mid; fHigh = fMid } else { low = mid; fLow = fMid }
  }
  return (low + high) / 2
}

// 由 FV,pmt,n 反求 r（二分法）
function rateFromFV(FV, n, pmt, { tol = 1e-10, maxIter = 100, rLow = 0, rHigh = 1 } = {}) {
  const f = (r) => fvAnnuity(pmt, r, n) - FV
  let low = rLow, high = rHigh
  let fLow = f(low), fHigh = f(high)
  let expand = 0
  while (fLow * fHigh > 0 && expand < 8) {
    high *= 2
    fHigh = f(high)
    expand++
  }
  for (let i = 0; i < maxIter; i++) {
    const mid = (low + high) / 2
    const fMid = f(mid)
    if (Math.abs(fMid) < tol) return mid
    if (fLow * fMid <= 0) { high = mid; fHigh = fMid } else { low = mid; fLow = fMid }
  }
  return (low + high) / 2
}

// NPV/IRR
function npv(rate, cashflows) {
  // cashflows: [c0, c1, ..., cn], 期末计息（普通年金）
  return cashflows.reduce((acc, c, i) => acc + c / Math.pow(1 + rate, i), 0)
}

function irr(cashflows, { tol = 1e-10, maxIter = 100, rLow = -0.99, rHigh = 1 } = {}) {
  const f = (r) => npv(r, cashflows)
  let low = rLow, high = rHigh
  let fLow = f(low), fHigh = f(high)
  // 扩展上界直至异号或达到限制
  let expand = 0
  while (fLow * fHigh > 0 && expand < 10) {
    high = (high + 1) * 2 - 1 // 逐步扩到更高
    fHigh = f(high)
    expand++
  }
  for (let i = 0; i < maxIter; i++) {
    const mid = (low + high) / 2
    const fMid = f(mid)
    if (Math.abs(fMid) < tol) return mid
    if (fLow * fMid <= 0) { high = mid; fHigh = fMid } else { low = mid; fLow = fMid }
  }
  return (low + high) / 2
}

// 利率换算
function effectiveAnnualFromPeriodic(rp, m = 12) { // rp: 每期利率
  return Math.pow(1 + rp, m) - 1
}
function periodicFromNominalAPR(apr, m = 12) {
  return apr / m
}
function effectiveAnnualFromNominal(apr, m = 12) {
  return Math.pow(1 + apr / m, m) - 1
}

// 贷款现金流（借款人视角）：t0 收到本金-手续费，之后每期支出月供+每期费用
function buildLoanCashflows({ principal, months, pmt, upfrontFee = 0, periodicFee = 0 }) {
  const flows = []
  flows.push(principal - upfrontFee) // t0
  for (let i = 1; i <= months; i++) {
    flows.push(-(pmt + periodicFee))
  }
  return flows
}

export {
  round,
  pvAnnuity, fvAnnuity,
  pmtFromPV, pmtFromFV,
  nFromPV, nFromFV,
  rateFromPV, rateFromFV,
  npv, irr,
  effectiveAnnualFromPeriodic, periodicFromNominalAPR, effectiveAnnualFromNominal,
  buildLoanCashflows
}
